import React from 'react';
import { useMap } from 'react-leaflet';

import useThrottle from '../../hooks/useThrottle';

import { Icon, IconButton, Stack, StackProps } from '@wegroup/design-system';

const LeafletZoomButtons: React.FC<React.PropsWithChildren<StackProps>> = (
  styleProps,
) => {
  const map = useMap();

  const currentZoom = map.getZoom();
  const maxZoom = map.getMaxZoom();
  const minZoom = map.getMinZoom();

  const isMaxZoom = maxZoom === currentZoom;
  const isMinZoom = minZoom === currentZoom;

  const zoomDuration = 300;
  const [throttledZoomIn] = useThrottle(() => map.zoomIn(), zoomDuration);
  const [throttledZoomOut] = useThrottle(() => map.zoomOut(), zoomDuration);

  return (
    <Stack
      bg="white"
      borderRadius="md"
      overflow="hidden"
      direction="column"
      spacing="0"
      {...styleProps}
    >
      <IconButton
        variant="grayedGhost"
        aria-label="Zoom in"
        borderRadius="0"
        _focus={{
          outline: 'none',
        }}
        icon={
          <Icon
            name="IconPlusFilled"
            color={isMaxZoom ? 'primary.50' : 'primary.500'}
          />
        }
        onClick={throttledZoomIn}
        isDisabled={isMaxZoom}
      />
      <IconButton
        variant="grayedGhost"
        aria-label="Zoom out"
        borderRadius="0"
        _focus={{
          outline: 'none',
        }}
        icon={
          <Icon
            name="IconMinus"
            color={isMinZoom ? 'primary.50' : 'primary.500'}
          />
        }
        onClick={throttledZoomOut}
        disabled={isMinZoom}
      />
    </Stack>
  );
};

export default LeafletZoomButtons;
